export enum OrderLineStatus {
    UNKNOWN,
    SHOPPINGCART,
    PAID,
    REFUNDED,
    PARTIALREFUND,
    SUCCESSFULPAYMENTDETECTEDFROMSTRIPE
}